import { TermsState } from './state';
import { termsInitialState } from './initial-state';
import { TermsActions } from './action-creators';
import * as actions from './actions';

export const termsReducer = (
  state: TermsState = termsInitialState,
  action: TermsActions
): TermsState => {
  switch (action.type) {
    case actions.UPDATE_TERMS: {
      return {
        ...state,
        [action.termName]: action.newDate,
      };
    }

    default: {
      return { ...state };
    }
  }
};
